import { render, staticRenderFns } from "./DealWorkflowTreeBranch.vue?vue&type=template&id=4163a7d6&scoped=true"
import script from "./DealWorkflowTreeBranch.vue?vue&type=script&lang=js"
export * from "./DealWorkflowTreeBranch.vue?vue&type=script&lang=js"
import style0 from "./DealWorkflowTreeBranch.vue?vue&type=style&index=0&id=4163a7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4163a7d6",
  null
  
)

export default component.exports